<!-- src/views/pages/superadmin/companies/companies-list.vue -->
<template>
  <layout-header></layout-header>
  <layout-sidebar></layout-sidebar>
  <!-- Page Wrapper -->
  <div class="page-wrapper dq-platform">
    <div class="content">
      <!-- Breadcrumb -->
      <div
        class="d-md-flex d-block align-items-center justify-content-between mb-3"
      >
        <breadcrumb :title="title" :text="text" :text1="text1" />

        <div
          class="d-flex my-xl-auto right-content align-items-center flex-wrap dq-page-actions"
        >
          <div class="me-2 mb-2">
            <div
              class="d-flex align-items-center border bg-white rounded p-1 me-2"
            >
              <router-link
                to="/super-admin/companies"
                class="btn btn-icon btn-sm active bg-primary text-white me-1"
              >
                <i class="ti ti-list-tree"></i>
              </router-link>
              <router-link
                to="/super-admin/companies-grid"
                class="btn btn-icon btn-sm"
              >
                <i class="ti ti-layout-grid"></i>
              </router-link>
            </div>
          </div>

          <div class="me-2 mb-2">
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                <i class="ti ti-file-export me-1"></i>Export
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportCompanies('pdf')"
                  >
                    <i class="ti ti-file-type-pdf me-1"></i>Export as PDF
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="exportCompanies('excel')"
                  >
                    <i class="ti ti-file-type-xls me-1"></i>Export as Excel
                  </a>
                </li>
              </ul>
            </div>
          </div>

          <div class="mb-2">
            <a
              href="javascript:void(0);"
              class="btn btn-primary d-flex align-items-center"
              @click="openAddModal"
            >
              <i class="ti ti-circle-plus me-2"></i>Add Company
            </a>
          </div>

          <div class="ms-2 head-icons">
            <a
              href="javascript:void(0);"
              data-bs-toggle="tooltip"
              data-bs-placement="top"
              data-bs-original-title="Collapse"
              id="collapse-header"
              @click="toggleHeader"
            >
              <i class="ti ti-chevrons-up"></i>
            </a>
          </div>
        </div>
      </div>
      <!-- /Breadcrumb -->

      <!-- STATS CARDS -->
      <div class="row">
        <!-- Total Companies -->
        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <span class="avatar avatar-lg bg-primary flex-shrink-0">
                  <i class="ti ti-building fs-16"></i>
                </span>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">
                    Total Companies
                  </p>
                  <h4>{{ totalCompanies }}</h4>
                </div>
              </div>
              <div id="total-chart">
                <apexchart
                  type="area"
                  width="50"
                  :options="totalChart.total"
                  :series="totalChart.series"
                >
                </apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /Total Companies -->

        <!-- Active Companies -->
        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <span class="avatar avatar-lg bg-success flex-shrink-0">
                  <i class="ti ti-building fs-16"></i>
                </span>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">
                    Active Companies
                  </p>
                  <h4>{{ activeCompanies }}</h4>
                </div>
              </div>
              <div id="active-chart">
                <apexchart
                  type="area"
                  width="50"
                  :options="activeChart.active"
                  :series="activeChart.series"
                >
                </apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /Active Companies -->

        <!-- Inactive Companies -->
        <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <span class="avatar avatar-lg bg-danger flex-shrink-0">
                  <i class="ti ti-building fs-16"></i>
                </span>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">
                    Inactive Companies
                  </p>
                  <h4>{{ inactiveCompanies }}</h4>
                </div>
              </div>
              <div id="inactive-chart">
                <apexchart
                  type="area"
                  width="50"
                  :options="inactiveChart.inactive"
                  :series="inactiveChart.series"
                >
                </apexchart>
              </div>
            </div>
          </div>
        </div>
        <!-- /Inactive Companies -->

        <!-- Company Location -->
        <!-- <div class="col-lg-3 col-md-6 d-flex">
          <div class="card flex-fill">
            <div
              class="card-body d-flex align-items-center justify-content-between"
            >
              <div class="d-flex align-items-center overflow-hidden">
                <span class="avatar avatar-lg bg-skyblue flex-shrink-0">
                  <i class="ti ti-map-pin-check fs-16"></i>
                </span>
                <div class="ms-2 overflow-hidden">
                  <p class="fs-12 fw-medium mb-1 text-truncate">
                    Company Location
                  </p>
                  <h4>{{ locationCount }}</h4>
                </div>
              </div>
              <div id="location-chart">
                <apexchart
                  type="area"
                  width="50"
                  :options="locationChart.location"
                  :series="locationChart.series"
                >
                </apexchart>
              </div>
            </div>
          </div>
        </div> -->
        <!-- /Company Location -->
      </div>
      <!-- /STATS CARDS -->

      <div class="card">
        <div
          class="card-header d-flex align-items-center justify-content-between flex-wrap row-gap-3"
        >
          <h5>Companies List</h5>
          <div
            class="d-flex my-xl-auto right-content align-items-center flex-wrap row-gap-3"
          >
            <!-- Search -->
            <div class="me-3">
              <input
                v-model="searchQuery"
                type="text"
                class="form-control"
                placeholder="Search companies..."
                @keyup.enter="applySearch"
              />
            </div>

            <!-- Date range -->
            <div class="me-3">
              <div class="input-icon-end position-relative">
                <input
                  type="text"
                  class="form-control date-range bookingrange"
                  ref="dateRangeInput"
                  placeholder="dd/mm/yyyy - dd/mm/yyyy"
                />
                <span class="input-icon-addon">
                  <i class="ti ti-chevron-down"></i>
                </span>
              </div>
            </div>

            <!-- Plan (UI only for now – no field in backend) -->
            <!-- Plan (dynamic from plans) -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Select Plan
                <span v-if="selectedPlanId"
                  >&nbsp;: {{ selectedPlanLabel }}</span
                >
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li v-for="p in plans" :key="p.id">
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setPlanFilter(p.id)"
                  >
                    {{ p.name }}
                  </a>
                </li>
                <li><hr class="dropdown-divider" /></li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setPlanFilter(null)"
                  >
                    Clear
                  </a>
                </li>
              </ul>
            </div>

            <!-- Status filter -->
            <div class="dropdown me-3">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Select Status
                <span v-if="selectedStatus">&nbsp;: {{ selectedStatus }}</span>
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatusFilter('Active')"
                  >
                    Active
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatusFilter('Inactive')"
                  >
                    Inactive
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setStatusFilter('')"
                  >
                    Clear Filter
                  </a>
                </li>
              </ul>
            </div>

            <!-- Sort -->
            <div class="dropdown">
              <a
                href="javascript:void(0);"
                class="dropdown-toggle btn btn-white d-inline-flex align-items-center"
                data-bs-toggle="dropdown"
              >
                Sort By : {{ sortOption }}
              </a>
              <ul class="dropdown-menu dropdown-menu-end p-3">
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('Recently Added')"
                  >
                    Recently Added
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('Ascending')"
                  >
                    Ascending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('Desending')"
                  >
                    Desending
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('Last Month')"
                  >
                    Last Month
                  </a>
                </li>
                <li>
                  <a
                    href="javascript:void(0);"
                    class="dropdown-item rounded-1"
                    @click.prevent="setSort('Last 7 Days')"
                  >
                    Last 7 Days
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- TABLE -->
        <div class="card-body p-0">
          <div class="custom-datatable-filter table-responsive">
            <super-admin-company-table
              :companies="displayCompanies"
              :loading="loading"
              @edit="openEditModal"
              @delete="setDeleteCompany"
            />
          </div>
        </div>
      </div>
    </div>

    <div
      class="footer d-sm-flex align-items-center justify-content-between border-top bg-white p-3"
    >
      <p class="mb-0">2014 - {{ new Date().getFullYear() }} &copy; DoneQuick HR & Payroll</p>
      <p>
        Powered by <a href="#" @click.prevent class="text-primary">DoneQuick Technological World</a>
      </p>
    </div>
  </div>
  <!-- /Page Wrapper -->

  <!-- Modal component (props + events wired like the Grid page) -->
  <companies-crm-modal
    :company="editCompany"
    :delete-company="deleteCompany"
    @company-updated="refreshCompanyList"
    @modal-closed="clearEditCompany"
  />
</template>

<script setup>
import "daterangepicker/daterangepicker.css";
import "daterangepicker/daterangepicker.js";

import { ref, computed, onMounted } from "vue";
import moment from "moment";
import DateRangePicker from "daterangepicker";
import * as bootstrap from "bootstrap";

import SuperAdminCompanyTable from "./super-admin-company-table.vue";
import { useCompanyStore } from "@/stores/companyStore";
import { usePlanStore } from "@/stores/planStore";
import companyService from "@/services/super-admin/companyService";
import { toast } from "@/utils/toast";

import {
  totalChart as totalChartConfig,
  activeChart as activeChartConfig,
  inactiveChart as inactiveChartConfig,
  locationChart as locationChartConfig,
} from "./data";

// Page labels
const title = "Companies";
const text = "Superadmin";
const text1 = "Companies List";

// Stores
const companyStore = useCompanyStore();
const planStore = usePlanStore();

// UI state
const dateRangeInput = ref(null);
const selectedStatus = ref(""); // "Active" / "Inactive" / ""
const selectedPlanId = ref(null); // plan.id (number) or null
const sortOption = ref("Last 7 Days");
const searchQuery = ref("");

const editCompany = ref(null);
const deleteCompany = ref(null);

// Date filters (normalized from picker)
const dateFrom = ref(null); // "YYYY-MM-DD"
const dateTo = ref(null); // "YYYY-MM-DD"

// Chart configs
const totalChart = totalChartConfig;
const activeChart = activeChartConfig;
const inactiveChart = inactiveChartConfig;
const locationChart = locationChartConfig;

// Derived data from stores
const companies = computed(() => companyStore.companies || []);
const loading = computed(() => companyStore.loading);

const plans = computed(() => planStore.plans || []);

// For the label in the dropdown
const selectedPlanLabel = computed(() => {
  if (!selectedPlanId.value) return "";
  const p = plans.value.find((pl) => pl.id === selectedPlanId.value);
  return p ? p.name : "";
});

// ---------- STATS ----------
const totalCompanies = computed(() => companies.value.length);

const activeCompanies = computed(
  () =>
    companies.value.filter((c) => {
      const status = String(c.status || "").toLowerCase();
      return status === "active";
    }).length
);

const inactiveCompanies = computed(
  () =>
    companies.value.filter((c) => {
      const status = String(c.status || "").toLowerCase();
      return status === "inactive";
    }).length
);

// ---------- FILTERED LIST (server-side; table receives store data directly) ----------
const displayCompanies = computed(() => companies.value);

const buildListParams = () => {
  const params = { per_page: 1000 };

  if (selectedStatus.value) params.status = selectedStatus.value;
  if (selectedPlanId.value) params.plan_id = selectedPlanId.value;
  if (dateFrom.value) params.date_from = dateFrom.value;
  if (dateTo.value) params.date_to = dateTo.value;
  if (searchQuery.value?.trim()) params.search = searchQuery.value.trim();

  if (sortOption.value === "Ascending") {
    params.sort_by = "company_name";
    params.sort_dir = "asc";
  } else if (sortOption.value === "Desending") {
    params.sort_by = "company_name";
    params.sort_dir = "desc";
  } else if (sortOption.value === "Recently Added") {
    params.sort_by = "created_at";
    params.sort_dir = "desc";
  }

  return params;
};

// ---------- METHODS ----------
const toggleHeader = () => {
  document.getElementById("collapse-header")?.classList.toggle("active");
  document.body.classList.toggle("header-collapse");
};

const setStatusFilter = (status) => {
  selectedStatus.value = status;
  refreshCompanyList();
};

const setPlanFilter = (planId) => {
  selectedPlanId.value = planId ? Number(planId) : null;
  refreshCompanyList();
};

const setSort = (option) => {
  sortOption.value = option;

  if (option === "Last 7 Days") {
    const start = moment().subtract(7, "days");
    const end = moment();
    bookingRange(start, end);
    return;
  }

  if (option === "Last Month") {
    const start = moment().subtract(1, "month").startOf("month");
    const end = moment().subtract(1, "month").endOf("month");
    bookingRange(start, end);
    return;
  }

  refreshCompanyList();
};

const applySearch = () => {
  refreshCompanyList();
};

const openAddModal = () => {
  editCompany.value = null;
  deleteCompany.value = null;

  const el = document.getElementById("add_company");
  if (el) {
    const modal = bootstrap.Modal.getOrCreateInstance(el);
    modal.show();
  }
};

const openEditModal = (company) => {
  editCompany.value = company ? { ...company } : null;

  const el = document.getElementById("add_company");
  if (el) {
    const modal = bootstrap.Modal.getOrCreateInstance(el);
    modal.show();
  }
};

const setDeleteCompany = (company) => {
  deleteCompany.value = company || null;

  const el = document.getElementById("delete_modal");
  if (el) {
    const modal = bootstrap.Modal.getOrCreateInstance(el);
    modal.show();
  }
};

const clearEditCompany = () => {
  editCompany.value = null;
  deleteCompany.value = null;
};

const refreshCompanyList = async () => {
  await companyStore.fetchCompanies(buildListParams());
};

const downloadBlob = (blob, filename) => {
  const url = window.URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

const exportCompanies = async (format) => {
  try {
    const res = await companyService.export(
      {
        status: selectedStatus.value || undefined,
        plan_id: selectedPlanId.value || undefined,
        date_from: dateFrom.value || undefined,
        date_to: dateTo.value || undefined,
        search: searchQuery.value?.trim() || undefined,
      },
      format
    );
    downloadBlob(
      res.data,
      format === "pdf" ? "companies-export.pdf" : "companies-export.xlsx"
    );
  } catch (error) {
    toast(
      error?.response?.data?.message || "Failed to export companies",
      "error"
    );
  }
};

// ---------- DATE RANGE INIT ----------
const bookingRange = (start, end) => {
  if (dateRangeInput.value) {
    dateRangeInput.value.value =
      start.format("DD/MM/YYYY") + " - " + end.format("DD/MM/YYYY");
  }

  dateFrom.value = start.startOf("day").format("YYYY-MM-DD");
  dateTo.value = end.endOf("day").format("YYYY-MM-DD");
  refreshCompanyList();
};

onMounted(async () => {
  await planStore.fetchPlans();

  // Init date range picker
  if (dateRangeInput.value) {
    const start = moment().subtract(6, "days");
    const end = moment();

    new DateRangePicker(
      dateRangeInput.value,
      {
        startDate: start,
        endDate: end,
        ranges: {
          Today: [moment(), moment()],
          Yesterday: [
            moment().subtract(1, "days"),
            moment().subtract(1, "days"),
          ],
          "Last 7 Days": [moment().subtract(6, "days"), moment()],
          "Last 30 Days": [moment().subtract(29, "days"), moment()],
          "This Month": [moment().startOf("month"), moment().endOf("month")],
          "Last Month": [
            moment().subtract(1, "month").startOf("month"),
            moment().subtract(1, "month").endOf("month"),
          ],
        },
      },
      bookingRange
    );

    // initialize with default range (also sets dateFrom/dateTo)
    bookingRange(start, end);
  }
});
</script>


